import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ToroLocationState } from './toro-location.entity';
import { toroLocationSelectors } from './toro-location.reducers';

export const toroLocationFeatureSelector = createFeatureSelector<ToroLocationState>('locationState');


export const getLocationsState = createSelector(
    toroLocationFeatureSelector,
    (state: ToroLocationState) => state
)

export const getlocationsForAccount = createSelector(getLocationsState, state => {

    // console.log(state.entities);
    if (state && state != null) {
        return Object.keys(state.entities).map(id => state.entities[id]);
    }
});

export const getCurrentLocation = createSelector(
    getLocationsState,
    state => state.currentLocation
);

export const getLocationById = (locId) => createSelector(
    getLocationsState,
    state => state.entities[locId]
);

export const getCurrentLocationDetail = createSelector(
    getLocationsState,
    state => state.locationDetail
);

export const getLocationDetailById = createSelector(
    getLocationsState,
    (state, id) => state.entities[id]
)


